import { Error404 } from '@app/features/errors/components/Error404';
import PrivateRoutes from '@app/routes/PrivateRoutes';
import { useAuthContext } from '@context/auth/useAuthContext';
import { RoutingProvider } from '@context/routing/RoutingProvider';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import { App } from '../App';

const AppRoutes: FC = () => {
  const { t } = useTranslation();
  const { auth, isInitialized } = useAuthContext();
  return (
    <Routes>
      <Route element={<App />}>
        {auth && isInitialized ? (
          <>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/auth/callback" element={<Navigate to="/dashboard" replace />} />
            <Route
              path="/*"
              element={
                <RoutingProvider>
                  <PrivateRoutes />
                </RoutingProvider>
              }
            />
          </>
        ) : (
          <Route
            path="*"
            element={<div className="flex items-center justify-center h-screen">{t('common-loading')}</div>}
          />
        )}
      </Route>
      <Route path="/404">
        <Route index element={<Error404 />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
